import { AbstractMutableMapyktux9ubhc1g as AbstractMutableMap } from './AbstractMutableMap.mjs';
import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import {
  HashMapKeys28ggmxpft3hz9 as HashMapKeys,
  HashMapValues3umcxpfyfunqf as HashMapValues,
  HashMapEntrySet29p2ksc4wcy5i as HashMapEntrySet,
} from './HashMapEntry.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_HashMap(_this__u8e3s4) {
  _this__u8e3s4.entriesView_1 = null;
}
var HashMapClass;
function HashMap() {
  if (HashMapClass === VOID) {
    class $ extends AbstractMutableMap() {
      static new_kotlin_collections_HashMap_xg4pkp_k$(internalMap) {
        var $this = this.new_kotlin_collections_AbstractMutableMap_wd9kkp_k$();
        init_kotlin_collections_HashMap($this);
        $this.internalMap_1 = internalMap;
        return $this;
      }
      static new_kotlin_collections_HashMap_2a5kxx_k$() {
        return this.new_kotlin_collections_HashMap_xg4pkp_k$(InternalHashMap().new_kotlin_collections_InternalHashMap_iefrky_k$());
      }
      static new_kotlin_collections_HashMap_kycc7v_k$(initialCapacity, loadFactor) {
        return this.new_kotlin_collections_HashMap_xg4pkp_k$(InternalHashMap().new_kotlin_collections_InternalHashMap_uj162q_k$(initialCapacity, loadFactor));
      }
      static new_kotlin_collections_HashMap_5ewlp_k$(initialCapacity) {
        return this.new_kotlin_collections_HashMap_kycc7v_k$(initialCapacity, 1.0);
      }
      static new_kotlin_collections_HashMap_gc38m_k$(original) {
        return this.new_kotlin_collections_HashMap_xg4pkp_k$(InternalHashMap().new_kotlin_collections_InternalHashMap_c4hmjh_k$(original));
      }
      clear_j9egeb_k$() {
        this.internalMap_1.clear_j9egeb_k$();
      }
      containsKey_aw81wo_k$(key) {
        return this.internalMap_1.contains_vbgn2f_k$(key);
      }
      containsValue_yf2ykl_k$(value) {
        return this.internalMap_1.containsValue_yf2ykl_k$(value);
      }
      createKeysView_aa1bmb_k$() {
        return HashMapKeys().new_kotlin_collections_HashMapKeys_s1wvpe_k$(this.internalMap_1);
      }
      createValuesView_4isqvv_k$() {
        return HashMapValues().new_kotlin_collections_HashMapValues_4lttdc_k$(this.internalMap_1);
      }
      get_entries_p20ztl_k$() {
        var tmp0_elvis_lhs = this.entriesView_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = HashMapEntrySet().new_kotlin_collections_HashMapEntrySet_7nlww9_k$(this.internalMap_1);
          this.entriesView_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      get_wei43m_k$(key) {
        return this.internalMap_1.get_wei43m_k$(key);
      }
      put_4fpzoq_k$(key, value) {
        return this.internalMap_1.put_4fpzoq_k$(key, value);
      }
      remove_gppy8k_k$(key) {
        return this.internalMap_1.remove_gppy8k_k$(key);
      }
      get_size_woubt6_k$() {
        return this.internalMap_1.get_size_woubt6_k$();
      }
      putAll_wgg6cj_k$(from) {
        return this.internalMap_1.putAll_wgg6cj_k$(from);
      }
    }
    initMetadataForClass($, 'HashMap', $.new_kotlin_collections_HashMap_2a5kxx_k$, VOID, [KtMutableMap()]);
    HashMapClass = $;
  }
  return HashMapClass;
}
//region block: exports
export {
  HashMap as HashMap1a0ld5kgwhmhv,
};
//endregion

//# sourceMappingURL=HashMap.mjs.map
